import { network } from 'services/network';

import { QueryParams } from 'api/queries/highLevelProgram.query';

export const ENDPOINT = 'api/bo/highLevelProgram';

export const highLevelProgram = (params: QueryParams) => {
    return network.post(ENDPOINT, params).then((response) => response.data);
};
